// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"AtBizCard_pageContainer__3kiSS"};